import React, { useEffect } from 'react';
import { useStore } from '../../store/useStore';
import { useNavigate } from "react-router-dom";

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const appLogo = useStore((state) => state.appLogo);
  const user = useStore((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.id) {
      navigate("/dashboard");
    }
  }, [user]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-black flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          {/* <a href="https://ezyvibes.com" target='_blank' className="flex items-center justify-center"> */}
          <div className="flex items-center justify-center">
            <img src="https://res.cloudinary.com/drive-cloud/image/upload/v1756090835/Asset_1-removebg-preview_cbbaej.png" alt="Ezyvibes Logo" className="w-60 mx-auto" />
          </div>
          {/* </a> */}
        </div>
        {/* <h1 className="text-2xl font-bold text-center text-gray-900 dark:text-white">
          ezyvibes
        </h1> */}
      </div>
      <div className="mt-4 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white dark:bg-gray-800 py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;